import { useAppSelector } from '@/utils/useAppSelector'

import { LOGIN_STATUS } from '../user/userSlice'

export const useIsLoggedIn = () => {
  return useAppSelector((state) => state.user.loginStatus === LOGIN_STATUS.LOGGED_IN)
}
